import React from 'react';
import { connect } from 'dva';
import { Link } from 'dva/router';
import {
  Button,
  Modal,
  Icon,
  Upload,
  Table,
  Alert,
  Row,
  Col,
  Input,
  Popover,
  message
} from 'antd';

import moment from 'moment';
import intl from 'react-intl-universal';

import withTracker from '../../common/tracker';
import { createIFrameForCB, replaceUrlToHttps, CommonDataCollect } from 'utils/utils';

import upComing from '../../assets/svg/upcoming.svg';

import defaultImg from '../../assets/default.svg';

import styles from './Csv.less';
import { style } from '@material-ui/system';
import { relative } from 'path';

const { Search } = Input;

let userId = ['bqa49860e4rllmptor3g','c7l6qkq2qhp000e5dg5g','c8svftaimtqg00f4pqv0', 'c6frfk046ft000ccnl6g', 'c3filti8i06000epj0i0', 'c9lhfge67o9g008utq70', 'bum87g4pahj000btual0', 'c39m6dggcg1g00deppig', 'c88ihaucaqgg00d10lng', 'c8j4s3csn4l000bgpmog', 'c76207pgicog009urfeg', 'c98sk5i4q7a000ah6mdg', 'c89rkfgm759g00fnm13g', 'c98ab8bbjvhg00f5rnvg', 'c71a14u2knlg00eqp3r0', 'c7gmv6665bmg00aaf2ng', 'c6qf64fobeqg009p15jg', 'c3ip2355npbg00cckpp0', 'c7mar9a2qhp000e6sda0', 'c9lclufehec000bngnhg', 'bs9gm75l1h2000erkve0', 'beanvlbcu2umhegpatj0', 'c61ktuav51s0009otjs0', 'c2u6kqjpu0ng00b5fq60', 'c8ee4v8au14000at4c10', 'bof48adqp3n51c905pkg', 'bkj08hld0c8mrs27a6ug', 'bst45lsfua3000dus8v0', 'c5cda0jln4og00dpasm0', 'c7ngqr8f1ec000cuoie0', 'boab3dtqp3n76fig7t70', 'bqn8fklqp3n79humv70g', 'c7p7r08uhi3g00b1dhr0', 'c8lddakh7eng009r2i5g', 'bub8oo9fvl5g009go3cg', 'c9299na2hq0000bqmnb0', 'bok4rqdqp3n3abrvperg', 'bvhu4a3q1dsg0081nekg', 'c4ns43jaf7ig00dqhmt0', 'c244p7e595v000d5meig', 'c7f6jvdpil0000dbrvhg', 'c85hhojabs1000c1ml20', 'c2ej2f6np9kg00dh03rg', 'c79k893avmbg00fh75lg', 'c8dl3j8au14000as3ih0', 'c69a273tk80g00d2234g', 'bv9fdq45v12g00e43alg', 'bng5jjabcd4000bjkki0', 'c97q2l2he7o000bbgtgg', 'c9865da4q7a000afjvkg', 'bupltcml4nng00f611r0', 'c6einrmlvlhg008a8q70', 'c83ahc2j6t7g00fk4mj0', 'bu5v80bodfv000a0ccu0', 'c9dincfqh70g00bge8vg', 'bsti71fr7ui000a8eubg', 'c7fkna8ueva000f1kqi0', 'c77hua9uh2og009o5eog', 'c5p04fremfg000eqs8c0', 'bphtpf5qp3ndqjlhbdmg', 'c530pcpbopq0008qpleg', 'bp279sdqp3n5mj1nhlc0', 'c8bfpuv44cg0008ouorg', 'c823bsfhb5pg009sncvg', 'c036psn2gacg00clf33g', 'c8cerhv7umig00fm5890', 'c5i9ifa5deu000fhg0h0', 'c9fbfo6402a000ebarl0', 'c84qidgnv3bg00fnfh9g', 'bpalaadqp3n5vhmo49u0', 'c9geu2uo90qg00ajtkcg', 'bikcpu5d0c8oegcndpe0', 'c750h6g53s0g00f4qctg', 'c9e960fqh70g00bhcde0', 'bsge6ta5uk4000b9nj1g', 'c8oapumvgm0000cj0apg', 'c886b7gm759g00flmhf0', 'bu1okj5g8qt000cvj6f0', 'c9m3p7667o9g0090ip0g', 'c8vbgl42lq2000bu3dj0', 'c7i0qtu65bmg00ac39eg', 'c9gvsvcca3ng00btqri0', 'c2eon5unp9kg00dh7d7g', 'c0allh2k1tp000bhtqd0', 'c9gcvcfqci0000dre8fg', 'c1jm389tqfcg0098ddkg', 'c9jkp9s5t5og00dh2kc0', 'c7io5iu65bmg00ad084g', 'c9lpk8m67o9g008vkb4g', 'c9kud13tlbr000evdsag']

export class Csv extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      isSync: false,
      showImportDialog: false,
      fileList: [],
      progress: 0,
      unloadResultList: [],
      totalNumber: 0,
      orderData: [],
      uploadStatus: true,
      viaibleAE: false,
      prodData: [],
      attention:false
    };
  }

  componentDidMount() {
    this.getProductList();
    this.getOrderList();

    if (localStorage.getItem('csvOrderIng')) {
      this.loopOrderResult();
    }

    this.setState({
      attention:Boolean(localStorage.getItem('attention1'))
    })

    CommonDataCollect({
        event_type: 'subscription_analysis',
        action: 'browse_csv_tab',
    })

    console.log(this.props.localAEInfo, this.props.localAEInfo?.affiliateStatus)
  }

  componentWillUnmount() {
    clearInterval(this.uploadTimer);
    clearInterval(this.loopTimer);
  }

  getProductList = () => {
    // 获取商品上传记录
    this.props.dispatch({
      type: 'newfeature/prouctlist',
      payload: {
        data: null,
        cancelMessage: true
      }
    });
  };

  getOrderList = () => {
    // 获取订单上传记录
    this.props.dispatch({
      type: 'newfeature/orderlist',
      payload: {
        data: {
          current: this.currentPage,
          page_size: this.pageSize
        },
        cancelMessage: true,
        callback: d => {
          if (d.code == 2000) {
            let list = d.data.orders || [];
            list.forEach((item, i) => {
              // item.orderStatus = d.data.csvSuccessStatus[i];
              if ([2, 3].includes(item.status)) {
                localStorage.setItem('csvOrderIng', item.file_id);
                this.loopOrderResult();
              }
            });

            list = list.map(item => {
              return {
                ...item,
                loading:false,
                loading2:false
              }
            })

            this.setState({
              orderData: list,
              totalNumber: d.data.count
            });
          } else {
            this.setState({
              orderData: []
            });
          }
        }
      }
    });
  };

  changePage = v => {
    // 翻页
    this.currentPage = v;
    this.getOrderList();
  };

  setIsSync = status => {
    // 设置是否正在同步订单
    if (status) {
      this.setState({
        isSync: true,
        loopSync: true
      });
    } else {
      this.setState({
        isSync: false,
        loopSync: false
      });
    }
  };

  hideImport = () => {
    // 隐藏下单弹窗
    this.setState({
      showImportDialog: false,
      progress: 0,
      unloadResultList: [],
      fileList: []
    });

    if (this.importCategory == 'product') {
      this.getProductList();
    } else {
      this.getOrderList();
    }
  };

  showImport = v => {
    // 显示上传弹窗
    this.importCategory = v;
    this.setState({
      showImportDialog: true
    });
  };

  changeFile = e => {
    const { file } = e;

    if (file.size / 1048576 > 8) {
      console.log('>8M');
      return;
    }

    this.setState({
      fileList: [e.file],
      progress: 0,
      uploadStatus: true
    });
  };

  setProgress = () => {
    // 设置进度
    this.setState({
      progress: 1
    });

    this.uploadTimer = setInterval(() => {
      const { progress } = this.state;
      const v = Math.floor(Math.random() * 50 + 1);
      if (progress + v > 400) {
        clearInterval(this.uploadTimer);
        return;
      }
      this.setState({
        progress: progress + v
      });
    }, 1000);
  };

  startImport = () => {
    // 开始上传
    const { fileList } = this.state;
    const formData = new FormData();
    formData.append('file', fileList[0]);
    this.setProgress();
    this.props.dispatch({
      type:
        this.importCategory === 'product'
          ? 'newfeature/productupload'
          : 'newfeature/orderupload',
      payload: {
        data: formData,
        cancelMessage: true,
        callback: d => {
          clearInterval(this.uploadTimer);
          if (d.code === 2000) {
            if (d.data.length === 0) {
              if (this.importCategory === 'product') {
                this.setState({
                  unloadResultList: [{ name: fileList[0].name, result: true }],
                  progress: 502,
                  uploadStatus: true
                });
              } else {
                const { unloadResultList } = this.state;
                unloadResultList.unshift({
                  name: fileList[0].name,
                  result: true
                });
                this.setState({
                  unloadResultList,
                  progress: 502,
                  uploadStatus: true
                });
              }
            } else {
              const { unloadResultList } = this.state;
              unloadResultList.unshift({
                name: fileList[0].name,
                data: d.data,
                result: false
              });
              this.setState({
                unloadResultList,
                progress: 502,
                uploadStatus: false
              });
            }
          } else {
            const result = d.code === 2010;
            this.setState({
              unloadResultList: [
                {
                  name: fileList[0]?.name,
                  result,
                  msg: d.msg
                }
              ],
              progress: 502,
              uploadStatus: result
            });
          }
        }
      }
    });
  };

  getRebates = record => {
    // 获取下单产品返点的url
    if (record.status > 1) {
      return;
    }
    if (localStorage.getItem('csvOrderIng')) {
      // 正在下单
      return;
    }

    if (this.props.userInfo.code || localStorage.getItem('userCode')) {
      createIFrameForCB(this.props.userInfo, 'placeorder', '', '', '', '100001', this.props.localAEInfo?.affiliateStatus);
    }

    this.placeholder(record);
  };

  placeholder = record => {
    // 点击placeorder下单
    localStorage.setItem('csvOrderIng', record.file_id);
    this.props.dispatch({
      type: 'newfeature/order',
      payload: {
        data: {
          file_id: record.file_id
        },
        callback: d => {
          if (d.code == 2000) {
            this.getOrderList();
            this.loopOrderResult();
          } else {
            localStorage.removeItem('csvOrderIng');
          }
        }
      }
    });
  };

  loopOrderResult = () => {
    // 轮询下单是否完成
    clearInterval(this.loopTimer);
    this.loopTimer = setInterval(() => {
      if (!localStorage.getItem('csvOrderIng')) {
        clearInterval(this.loopTimer);
        return;
      }
      this.props.dispatch({
        type: 'newfeature/looporder',
        payload: {
          data: {
            file_id: localStorage.getItem('csvOrderIng')
          },
          callback: d => {
            if (d.code == 2000) {
              if (d.data.status > 3) {
                localStorage.removeItem('csvOrderIng');
                this.getOrderList();
                clearInterval(this.loopTimer);
              }
            } else {
              localStorage.removeItem('csvOrderIng');
              clearInterval(this.loopTimer);
            }
          }
        }
      });
    }, 5000);
  };

  // 获取商品sku图片
  getProductSkuImage = sku => {
    let src = '';

    sku.aeop_s_k_u_propertys &&
      sku.aeop_s_k_u_propertys.aeop_sku_property &&
      sku.aeop_s_k_u_propertys.aeop_sku_property.forEach(item => {
        if (item.sku_image) {
          src = item.sku_image;
        }
      });
    return src || this.importAEProductImages.split(';')[0] || defaultImg;
  };

  getProductSkuName = (index, record) => {
    let name = '';

    record.aeop_s_k_u_propertys.aeop_sku_property.forEach((item, i) => {
      if (i == index) {
        name =
          item.property_value_definition_name || item.sku_property_value || '';
      }
    });
    return name;
  };

  getAeColumns = () => {
    const { prodData } = this.state;
    const skuRow = [
      {
        title: '',
        dataIndex: 'img',
        render: (text, record) => {
          const src = this.getProductSkuImage(record);
          return (
            <Popover
              placement="left"
              trigger="hover"
              content={
                <img
                  src={replaceUrlToHttps(src)}
                  style={{
                    width: '260px',
                    height: '260px',
                    objectFit: 'contain'
                  }}
                />
              }
            >
              <img src={replaceUrlToHttps(src)} style={{ height: 30 }} />
            </Popover>
          );
        }
      },
      {
        title: intl.get('product_edit.sku'),
        dataIndex: 'id',
        width: 270
      },
      {
        title: intl.get('product_edit.cost'),
        dataIndex: 'offer_sale_price',
        render: (v, record) => {
          return `$${record.offer_sale_price ||
            this.importAEProductSalePrice ||
            record.sku_price ||
            0}`;
        }
      },
      {
        title: intl.get('csv.price'),
        dataIndex: 'sku_price',
        render: (v, record) => {
          return `$${record.offer_sale_price ||
            this.importAEProductSalePrice ||
            record.sku_price ||
            0}`;
        }
      }
    ];

    prodData[0] &&
      prodData[0].aeop_s_k_u_propertys &&
      prodData[0].aeop_s_k_u_propertys.aeop_sku_property &&
      prodData[0].aeop_s_k_u_propertys.aeop_sku_property.forEach(
        (item, i) => {
          skuRow.splice(2 + i, 0, {
            title: item.sku_property_name,
            dataIndex: `a${i}`,
            render: (v, record) => {
              return this.getProductSkuName(i, record);
            }
          });
        }
      );

    return skuRow;
  };

  changeSearchKey = e => {
    this.setState({
      SkuValue: e.target.value
    });
  };

  addProductCheck = () => {
    const { SkuValue } = this.state;
    this.setState({
      viaibleAE: true
    });

    if (!SkuValue) {
      return;
    }

    let urls = null;

    if (SkuValue.includes('http')) {
      urls = SkuValue;
    } else {
      urls = `https://www.aliexpress.com/item/product/${SkuValue}.html`;
    }

    this.props.dispatch({
      type: 'newfeature/aeProductDetail',
      payload: {
        data: {
          url: urls
        },
        callback: d => {
          this.importAEProductSalePrice = 0;
          this.importAEProductImages = '';

          if (d.code == 2000) {
            let arr = [];

            if (
              d.data.aeop_ae_product_s_k_us &&
              d.data.aeop_ae_product_s_k_us.aeop_ae_product_sku
            ) {
              arr = d.data.aeop_ae_product_s_k_us.aeop_ae_product_sku;
            }
            this.importAEProductSalePrice = d.data.item_offer_site_sale_price;
            this.importAEProductImages = d.data.image_u_r_ls;
            this.setState({
              prodData: arr
            });
          } else {
            this.setState({
              prodData: []
            });
          }
        }
      }
    });
  };

  hideAlert = () => {
    this.setState({
      viaibleAE: false,
      SkuValue: null,
      prodData: []
    });
  };

  downloadFile = async (record) => {
    let user = localStorage.getItem('dser-pro-authority');
    let url = `${window.DSERS_API_CONFIG.HOST}/api/v1/csv/product/export?token=${user}&file_id=${record.file_id}&file_name=${record.file_name}`
    let response = await fetch(url, {
      method: 'get'
    })

    response.text().then(res => {
      if (res.includes('msg') && response.headers.get("content-type") != 'vnd.ms-excel') {
        let error = JSON.parse(res)
        if (error.code === 205) {
          message.error(intl.get('csv.token_error'),)
        } else {
          message.error(error.msg)
        }
      } else {
        window.open(url)
      }
    })

  }

  //下载2
  downloadFileTwo = async (record) => {
    let user = localStorage.getItem('dser-pro-authority');
    let url = `${window.DSERS_API_CONFIG.HOST}/api/v1/csv/order/export/failed?token=${user}&file_id=${record.file_id}`
    let response = await fetch(url, {
      method: 'get'
    })
    const { orderData }  = this.state

    let data = orderData.map(item => {
      if(item.file_id == record.file_id){
        return {
          ...item,
          loading2:true
        }
      }else{
        return item
      }
    })

    this.setState({
      orderData: data
    })

    response.text().then(res => {
      if (res.includes('msg') && response.headers.get("content-type") != 'vnd.ms-excel') {
        let error = JSON.parse(res)
        if (error.code === 205) {
          message.error(intl.get('csv.token_error'))
          this.resetList()
        } else {
          message.error(error.msg)
          this.resetList()
        }
      } else {
        window.open(url)
        this.resetList()
      }
    })

  }

  resetList = () => {
    const { orderData }  = this.state
    let data = orderData.map(item => {
      return {
        ...item,
        loading:false,
        loading2:false
      }
    })

    setTimeout(()=>{
      this.setState({
        orderData:data
      })
    },2000)
  }

  //下载3
  downloadFileThree = async (record) => {
    let user = localStorage.getItem('dser-pro-authority');
    let url = `${window.DSERS_API_CONFIG.HOST}/api/v1/csv/order/export/success?token=${user}&file_id=${record.file_id}`
    let response = await fetch(url, {
      method: 'get'
    })

    const { orderData }  = this.state

    let data = orderData.map(item => {
      if(item.file_id == record.file_id){
        return {
          ...item,
          loading:true
        }
      }else{
        return item
      }
    })

    this.setState({
      orderData: data
    })

    response.text().then(res => {
      if (res.includes('msg') && response.headers.get("content-type") != 'vnd.ms-excel') {
        let error = JSON.parse(res)
        if (error.code === 205) {
          message.error(intl.get('csv.token_error'),)
          this.resetList()
        } else {
          message.error(error.msg)
          this.resetList()
        }
      } else {
        window.open(url)
        this.resetList()
      }
    })

  }

  //下载4
  downloadFileFour = async (record) => {
    let user = localStorage.getItem('dser-pro-authority');
    let url = `${window.DSERS_API_CONFIG.HOST}/api/v1/csv/order/export/err?token=${user}`
    let response = await fetch(url, {
      method: 'get'
    })
    response.text().then(res => {
      if (res.includes('msg') && response.headers.get("content-type") != 'vnd.ms-excel') {
        let error = JSON.parse(res)
        if (error.code === 205) {
          message.error(intl.get('csv.token_error'),)
        } else {
          message.error(error.msg)
        }
      } else {
        window.open(url)
      }
    })

  }


  closeBannber = () => {
    localStorage.setItem('attention1', true)
    this.setState({
      attention: true
    })
  }

  importCategory = '';
  uploadTimer = null;
  loopTimer = null;
  pageSize = 10;
  currentPage = 1;
  user = localStorage.getItem('dser-pro-authority');
  productTemplateLink = 'https://images.dsers.com/files/import_products_demo.xlsx';
  orderTemplateLink = 'https://images.dsers.com/files/import_orders_demo.xlsx';
  searchKey = '';
  importAEProductSalePrice = 0;
  importAEProductImages = '';

  render() {
    const {
      newfeature = {},
      productLoading,
      orderLoading,
      getAeLoading
    } = this.props;

    const { productList } = newfeature;

    const {
      isSync,
      showImportDialog,
      fileList,
      progress,
      unloadResultList,
      totalNumber,
      orderData,
      uploadStatus,
      viaibleAE,
      SkuValue,
      prodData
    } = this.state;

    let productData = [];
    if (productList) {
      productData = [productList];
    }

    const pagination = {
      total: totalNumber,
      size: this.pageSize,
      onChange: this.changePage,
      hideOnSinglePage: false
    };

    const productColumns = [
      {
        title: intl.get('csv.order_table.date'),
        dataIndex: 'created_at',
        align: 'center',
        key: 'date',
        render: v => {
          return moment(v * 1000).format('YYYY/MM/DD');
        }
      },
      {
        title: intl.get('csv.order_table.file_name'),
        dataIndex: 'file_name',
        align: 'center',
        render: (v, record) => {
          return (
            <a
              style={{ color: '#ff8f00' }}
              onClick={() => {
                this.downloadFile(record)
              }}
            >
              <b>{v}</b>
            </a>
          );
        }
      }
    ];

    const orderColumns = [
      {
        title: intl.get('csv.order_table.date'),
        dataIndex: 'created_at',
        align: 'center',
        key: 'csv_id',
        render: v => {
          return moment(v * 1000).format('YYYY/MM/DD');
        }
      },
      {
        title: intl.get('csv.order_table.file_name'),
        dataIndex: 'file_name',
        align: 'center'
      },
      {
        title: intl.get('csv.order_table.successful_orders'),
        dataIndex: 'status',
        key: 'succ',
        align: 'center',
        render: (t, record) => {
          if(record.loading){
            return <>
              <span className={styles.placeholder}>
                <img src={require('../../assets/order/csv-loading.png')}></img>
                {intl.get('csv.download')}
              </span>
            </>
          }

          if ([1, 2, 3, 5].includes(t)) {
            return (
              <span className={styles.placeholder}>
                {intl.get('csv.download')}
              </span>
            );
          } else {
            return (
              <a
                style={{ color: '#ff8f00' }}
                onClick={() => {
                  this.downloadFileThree(record)
                }}
              >
                <b>{intl.get('csv.download')}</b>
              </a>
            );
          }
        }
      },
      {
        title: intl.get('csv.order_table.failed_orders'),
        dataIndex: 'status',
        align: 'center',
        key: 'fail',
        render: (t, record) => {
          if(record.loading2){
            return <>
              <span className={styles.placeholder}>
                <img src={require('../../assets/order/csv-loading.png')}></img>
                {intl.get('csv.download')}
              </span>
            </>
          }
          if ([1, 2, 3, 4].includes(t)) {
            return (
              <span className={styles.placeholder}>
                {intl.get('csv.download')}
              </span>
            );
          } else {
            return (
              <a
                style={{ color: '#ff8f00' }}
                onClick={() => {
                  this.downloadFileTwo(record)
                }}
              >
                <b>{intl.get('csv.download')}</b>
              </a>
            );
          }
        }
      },
      {
        title: intl.get('csv.order_table.action'),
        dataIndex: 'status',
        align: 'center',
        key: 'action',
        render: (t, record) => {
          return (
            <a
              style={{ color: t > 1 ? '' : '#ff8f00' }}
              className={t > 1 ? styles.placeholder : ''}
              role="button"
              tab-index="0"
              disabled={t > 1}
              onClick={() => {
                this.getRebates(record);
              }}
            >
              {[2, 3].includes(t) ? <Icon type="loading" /> : null}
              {localStorage.getItem('csvOrderIng') ? (
                intl.get('csv.pending')
              ) : t == 1 ? (
                <b>{intl.get('csv.place_order')}</b>
              ) : (
                intl.get('csv.place_order')
              )}
            </a>
          );
        }
      }
    ];

    const unloadProps = {
      onRemove: file => { },
      beforeUpload: file => {
        return false;
      },
      showUploadList: false,
      accept:
        '.csv, .xls, .xlsx, text/csv, application/csv, text/comma-separated-values, application/csv, application/excel, application/vnd.msexcel, text/anytext, application/vnd. ms-excel, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
    }

    return (
      <>
        <div className={styles.box}>
          {/* {
            !userId.includes(this.props.userInfo.user_id) ? (
              this.state.attention ? null : 
                <div className='orderTransit'>
                  <p className='tit'>Attention</p>
                  <p>Due to AliExpress system issue, your order may have a risk of repeated orders on AliExpress. Please check on AliExpress Order tab, and contact sellers for refund. DSers is communicating with AliExpress and working on solutions. </p>
                  <div className='close' onClick={this.closeBannber}>
                    <img src="https://img.dsers.com/shopify/order/close.png"></img>
                  </div>
                </div>
            ) : null
          } */}
          <h3 style={{ marginTop: 10 }}>{intl.get('csv.check_product')}</h3>
          <Row style={{ marginBottom: 34, position: 'relative' }}>
            <Col>
              <Input
                // enterButton={intl.get('csv.check')}
                // onSearch={this.addProductCheck}
                value={SkuValue}
                // allowClear
                onChange={this.changeSearchKey}
                size="large"
                suffix={
                  <i class="material-icons notranslate" onClick={() => {
                    this.setState({
                      SkuValue: ''
                    })
                  }} style={{ fontSize: '20px', cursor: 'pointer', position: 'relative', left: '-95px' }} >cancel</i>
                }
              />
              <Button className={styles.searchBtn} onClick={this.addProductCheck}>{intl.get('csv.check')}</Button>
            </Col>
          </Row>
          {/* <div className={styles.back}>
            <Link to="/newfeature">
              <Icon type="left" />
              {intl.get('csv.csv_bulk_order')}
            </Link>
          </div> */}
          {/* <Alert
            style={{ marginBottom: '34px', padding: '12px 16px' }}
            message={intl.get('csv.re_download_template')}
            type="warning"
            showIcon
          /> */}
          <h3>{intl.get('csv.products')}</h3>
          <p className={styles.extraContent}>
            <span>{intl.get('csv.product_tip')}</span>
          </p>
          <div className={styles.importBtn}>
            <a href={this.productTemplateLink} target="_blank">
              {intl.get('csv.download_template')}
            </a>
            <Button
              icon="plus"
              onClick={() => {
                this.showImport('product');
              }}
            >
              {intl.get('csv.import')}
            </Button>
          </div>
          <Table
            className={styles.csvTable}
            dataSource={productData}
            columns={productColumns}
            pagination={false}
            loading={productLoading}
            rowKey="file_id"
            bordered
          />
          <h3 style={{ marginTop: 34 }}>{intl.get('csv.orders')}</h3>
          <p className={styles.extraContent}>
            <span>{intl.getHTML('csv.order_tip')}</span>
          </p>
          <div className={styles.importBtn}>
            <a href={this.orderTemplateLink} target="_blank">
              {intl.get('csv.download_template')}
            </a>
            <Button
              icon="plus"
              onClick={() => {
                this.showImport('order');
              }}
            >
              {intl.get('csv.import')}
            </Button>
          </div>
          <Table
            className={styles.csvOrderTable}
            dataSource={orderData}
            columns={orderColumns}
            pagination={pagination}
            loading={orderLoading}
            rowKey="file_id"
            bordered
          />
        </div>

        {
          viaibleAE ? (
            <Modal
              visible={viaibleAE}
              title={null}
              maskClosable={false}
              destroyOnClose
              width={868}
              onCancel={this.hideAlert}
              footer={null}
            >
              <div className={styles.aeTable}>
                <Table
                  columns={this.getAeColumns()}
                  rowKey="id"
                  pagination={false}
                  dataSource={prodData}
                  loading={getAeLoading}
                />
              </div>
            </Modal>
          ) : null
        }

        <Modal
          visible={showImportDialog}
          title={
            this.importCategory == 'order'
              ? intl.getHTML('csv.upload_title_orders')
              : intl.getHTML('csv.upload_title_product')
          }
          maskClosable={false}
          destroyOnClose
          okText={intl.get('csv.upload_btn')}
          width={700}
          onCancel={this.hideImport}
          footer={
            <>
              <a
                href="https://www.messenger.com/t/DSersOfficial" dd="src"
                className={styles.helpBtn}
                target="_blank"
                rel="noopener noreferrer"
              >
                {intl.get('csv.need_help')}
              </a>
              <button
                type="button"
                className="ant-btn ant-btn-primary"
                disabled={progress > 0}
                style={{ height: '36px', display: 'flex', justifyContent: 'center', alignItems: 'center', color: '#fff', backgroundColor: progress > 0 ? '#e0e0e0' : '#ff8f00' }}
                onClick={this.startImport}
              >
                <i style={{ color: '#fff' }} class="material-icons">add</i><span>{intl.get('csv.import')}</span>
              </button>
            </>
          }
        >
          <div>
            {unloadResultList.length && this.importCategory !== 'order' ? (
              <div className={styles.unloadResultList} style={{}}>
                {unloadResultList.map((item, i) => {
                  if (item.result) {
                    return (
                      <Alert
                        style={{ marginBottom: 10 }}
                        message={`${item.name} ${intl.get('csv.upload_succ')}`}
                        type="success"
                        showIcon
                      />
                    );
                  }
                  if (item.data?.length >= 1) {
                    return item.data.map((p, k) => {
                      return (
                        <Alert
                          key={`key${k + 1}`}
                          style={{ marginBottom: 10 }}
                          message={p}
                          type="error"
                          showIcon
                        />
                      );
                    });
                  }
                  return this.importCategory !== 'order' ? (
                    <Alert
                      key={`key${i + 1}`}
                      style={{ marginBottom: 10 }}
                      message={`${item.name} ${item.msg ? item.msg : intl.get('csv.upload_fail')}`}
                      type="error"
                      showIcon
                    />
                  ) : (
                    <p key={`key${i + 1}`} style={{ color: 'red' }}>
                      <Icon type="paper-clip" />
                      {item.name}
                      <span style={{ width: 20, display: 'inline-block' }} />
                      {item.msg ? `${item.msg}` : (
                        <>
                          {intl.get('csv.click_here_to')}&nbsp;
                          <a
                            onClick={() => {
                              this.downloadFileFour()
                            }}
                          >
                            {intl.get('csv.download')}
                          </a>
                          &nbsp;{intl.get('csv.download_error')}
                        </>
                      )}
                    </p>
                  );
                })}
              </div>
            ) : null}
            <div className={styles.uploadBox}>
              <Upload
                {...unloadProps}
                onChange={e => {
                  this.changeFile(e);
                }}
              >
                <Button className={styles.chooseFileBtn}>{intl.get('csv.choose_csv_file')}</Button>
              </Upload>
              <p className={styles.fileBox}>
                <span className={styles.fileName}>
                  {fileList.length > 0
                    ? fileList[0].name
                    : (
                      <div className={styles.fileChooseCon}>
                        <img src={upComing} style={{ width: '30px', height: '30px', marginRight: '12px' }} /> {intl.get('csv.no_file_chosen')}
                      </div>
                    )}
                </span>
                {progress ? (
                  <b>
                    <span
                      style={{
                        width: progress,
                        backgroundColor: uploadStatus ? '#52c41a' : 'red'
                      }}
                    />
                  </b>
                ) : null}
              </p>
            </div>
            <p className={styles.mbText}>{intl.get('csv.max_8mb')}</p>
            <p className={styles.mbText}>
              <a
                href={
                  this.importCategory == 'product'
                    ? this.productTemplateLink
                    : this.orderTemplateLink
                }
              >
                {intl.get('csv.download_template')}&nbsp;
              </a>
              {intl.get('csv.upload_download_tip')}
            </p>
            {unloadResultList.length && this.importCategory == 'order' ? (
              <div className={styles.unloadResultList} style={{}}>
                {unloadResultList.map((item, i) => {
                  if (item.result) {
                    return (
                      <Alert
                        style={{ marginBottom: 10 }}
                        message={`${item.name} ${intl.get('csv.upload_succ')}`}
                        type="success"
                        showIcon
                      />
                    );
                  }
                  if (item.data?.length >= 1) {
                    return item.data.map((p, k) => {
                      return (
                        <Alert
                          key={`key${k + 1}`}
                          style={{ marginBottom: 10 }}
                          message={p}
                          type="error"
                          showIcon
                        />
                      );
                    });
                  }
                  return this.importCategory !== 'order' ? (
                    <Alert
                      key={`key${i + 1}`}
                      style={{ marginBottom: 10 }}
                      message={`${item.name} ${item.msg ? item.msg : intl.get('csv.upload_fail')}`}
                      type="error"
                      showIcon
                    />
                  ) : (
                    <p key={`key${i + 1}`} style={{ color: 'red' }}>
                      <Icon type="paper-clip" />
                      {item.name}
                      <span style={{ width: 20, display: 'inline-block' }} />
                      {item.msg ? `${item.msg}` : (
                        <>
                          {intl.get('csv.click_here_to')}&nbsp;
                          <a
                            onClick={() => {
                              this.downloadFileFour()
                            }}
                          >
                            {intl.get('csv.download')}
                          </a>
                          &nbsp;{intl.get('csv.download_error')}
                        </>
                      )}
                    </p>
                  );
                })}
              </div>
            ) : null}
          </div>
        </Modal>
      </>
    );
  }
}

@connect(({ newfeature, loading, topBtn, login, global }) => ({
  newfeature,
  userInfo: login.userInfo,
  loading: loading.models.newfeature,
  productLoading: loading.effects['newfeature/prouctlist'],
  orderLoading: loading.effects['newfeature/orderlist'],
  getAeLoading: loading.effects['newfeature/aeProductDetail'],
  topBtn,
  localAEInfo: global.localAEInfo,
}))
@withTracker
export default class CsvCommonent extends Csv { }
